// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListNameValue_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListNameValue';
  $t: string = 'SagaSchema.ListObjects.ListNameValue';

  public static GetMembers(): string[] {
    return ['ListNameValueId', 'Owner', 'IsDefault', 'DisplayValue', 'Color', 'ListNameId', 'Abreviation', 'Json'].concat(
      PersistentObject.GetMembers()
    );
  }

  public GetMembers(): string[] {
    return ListNameValue_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public IsDefault: boolean = false;
  public ListNameValueId: number = 0;
  public Owner: number;
  public DisplayValue: string;
  public Color: string = '#00FFFFFF';
  public ListNameId: number = 0;
  public Abreviation: string;
  public Json: string = '';

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.ListNameValueId;
  }
  get ParentObjId(): any {
    return this.ListNameId;
  }
  set ParentObjId(value: any) {
    this.ListNameId = value;
  }
  get Name(): string {
    return this.DisplayValue;
  }
  set Name(value: string) {
    this.DisplayValue = value;
  }
  get Value(): any {
    return this.ListNameValueId;
  }
  set Value(value: any) {
    this.ListNameValueId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
